import { trackMetaPageView } from "./metaConversions";

export const GOOGLE_ANALYTICS_ID = "G-L84LLCM7XR";

export function initializeGoogleAnalytics() {
  if (process.env.NODE_ENV !== "production") return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", GOOGLE_ANALYTICS_ID, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
  document.head.appendChild(script);
}

export function trackPage(page) {
  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", {
      page_title: page,
      page_path: window.location.pathname,
      user_project: "signup"
    });
  }

  trackMetaPageView();
}
